export const GET_PERSONALISED = 'Get Personalised Insurance'
export const ARROW = 'https://acko-cms.ackoassets.com/arrow_fuel_personalised_6e278879b6.svg'
